import trashIcon from '../images/icons/ic-remove.svg';
import starOrangeIcon from '../images/icons/ic-star-filled.svg';
import starGreyIcon from '../images/icons/ic-star-empty.svg';
import arrowRightIcon from '../images/icons/ic-go.svg';
import runningManLightIcon from '../images/icons/ic-athlete-light.svg';
import xLightIcon from '../images/icons/ic-close-light.svg';
import heartDarkIcon from '../images/icons/ic-save-dark.svg';
import heartFilledDarkIcon from '../images/icons/ic-save-filled-dark.svg';
import chevronLeftDark from '../images/icons/ic-back-dark.svg';
import chevronLeftLight from '../images/icons/ic-back-light.svg';
import chevronDoubleLeftDark from '../images/icons/ic-skip-back-dark.svg';
import chevronDoubleLeftLight from '../images/icons/ic-skip-back-light.svg';

export const ICONS = {
  trash: trashIcon,
  starOrange: starOrangeIcon,
  starGrey: starGreyIcon,
  arrowRight: arrowRightIcon,
  runningManLight: runningManLightIcon,
  xLight: xLightIcon,
  heartDark: heartDarkIcon,
  heartFilledDark: heartFilledDarkIcon,
  chevronLeftDark,
  chevronLeftLight,
  chevronDoubleLeftDark,
  chevronDoubleLeftLight,
};